import { render, staticRenderFns } from "./projectBigData.vue?vue&type=template&id=61f073f0&scoped=true"
import script from "./projectBigData.vue?vue&type=script&lang=js"
export * from "./projectBigData.vue?vue&type=script&lang=js"
import style0 from "./projectBigData.vue?vue&type=style&index=0&id=61f073f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f073f0",
  null
  
)

export default component.exports